import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
// components
import Modal from '@/components/ui/modals/Modal';
import SignInForm from '@/components/forms/SignInForm';
import CheckinForm from '@/components/forms/CheckInForm';
// styles
import styles from './styles.module.scss';
// models
import { makeSelectIsHost } from '@/models/event';
// helpers + hooks
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';

const SignInOrSignUpModal = ({ trigger, eventRefDetails, onSuccess, buttonText }) => {
  const handleSuccess = setShow => (data, eventRefDetails) => {
    onSuccess(data);
    setShow(false);
  };

  // const [isSignIn, setIsSignIn] = useState(eventRefDetails.accountStatus === 'ACTIVE');
  const [isSignIn, setIsSignIn] = useState(true);
  const { eventId = '' } = useParams();
  const isHost = useMemoizedSelector(makeSelectIsHost, eventId);

  const switchToSignUp = () => {
    setIsSignIn(false);
  };

  const switchToSignIn = () => {
    setIsSignIn(true);
  };

  const modalTitle = buttonText === 'Register' ? 'Register' : isSignIn ? 'Sign In' : 'Sign Up';

  const initialValues = ['8a219512-e253-4191-9f98-669c066e62bc', 'a5c8e27e-631e-44e4-bf0d-040e3015e73f'].includes(eventId) ? {} : {
    firstName: eventRefDetails.firstName,
    lastName: eventRefDetails.lastName,
    email: eventRefDetails.email,
  };

  const getRegisterForm = setShow => <><div className={styles.authLabel}>Already have an account? <div className={styles.authLink} onClick={switchToSignIn}>Sign in</div></div></>;
  const getSignInContent = setShow => (
    <>
      {isHost ? (
        <>
          <SignInForm
            initialValues={initialValues}
            onSuccess={handleSuccess(setShow)}
          />
          <div className={styles.authLabel}>
            Don't have an account?{' '}
            <div className={styles.authLink} onClick={switchToSignUp}>
              Sign up now
            </div>
          </div>
        </>
      ) : (
          <CheckinForm
            initialValues={initialValues}
            onSuccess={handleSuccess(setShow)}
          />
        )}
    </>
  );
  const getSignUpContent = setShow => (
    <>
      {isHost ? (
        <>
          <div className={styles.authLabel}>
            Already have an account?
            <div className={styles.authLink} onClick={switchToSignIn}>
              Sign in
            </div>
          </div>
        </>
      ) : (
          <CheckinForm
            initialValues={initialValues}
            onSuccess={handleSuccess(setShow)}
          />
        )}
    </>
  );
  return <Modal
    title={modalTitle}
    trigger={trigger}
    render={({ setShow }) => <div className={styles.formContainer}>
      {buttonText === 'Register' ? getRegisterForm(setShow) : isSignIn ? getSignInContent(setShow) : getSignUpContent(setShow)}
    </div >}
  />;
};

export default SignInOrSignUpModal;
